import React from 'react';
import SVG from 'react-inlinesvg';
//Imagens
import setaDefault from '../../static/img/icons/seta-baixo.svg';

import './Select.scss';

class Select extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectAberto: false,
      anoSelecionado: '2019',
    }
  }
  abreSelect = () => {
    this.setState ({
      selectAberto: !this.state.selectAberto
    });
  }
  seleciona = (e) => {
    this.props.selecionaAno(e);
    this.setState({
      anoSelecionado: e
    })
    this.abreSelect();
  }
  render() {
    return (
      <div className="select" className={`select select--${this.props.estilo}`}>
        <button
          onClick={this.abreSelect}
          className={this.state.selectAberto ? "select__botao select__botao--aberto" : "select__botao"}
        >
          <span className="select__texto">{this.state.anoSelecionado}</span> <SVG className="icone-select icone-select--branca" src={setaDefault} />
        </button>
        {this.state.selectAberto &&
          <ul className="select__lista">
            <li onClick={ ()=>this.seleciona('2019') }>2019</li>
            <li onClick={ ()=>this.seleciona('2018') }>2018</li>
            <li onClick={ ()=>this.seleciona('2017') }>2017</li>
          </ul>
        }
      </div>
    )
  }
}

export { Select }